const GO_LIVE_REASON_ACTIONS: Record<string, string> = {
  'issue-passes': 'issue passes again',
  'create-templates': 'create pass templates',
  'edit-templates': 'edit your pass templates',
  'send-messages': 'send messages to your passes',
  'update-passes': 'update your passes',
  'create-events': 'create events',
  'download-templates': 'edit your download pages',
};

export const goLiveActionPrefix = (locked = false): string =>
  locked ? 'Reactivate your subscription to' : 'Choose a plan to';

export const goLiveReasonMessage = (
  reason?: string | null,
  { locked = false }: { locked?: boolean } = {}
): string | null => {
  if (!reason) return null;
  const action = GO_LIVE_REASON_ACTIONS[reason];
  if (!action) return null;
  return `${goLiveActionPrefix(locked)} ${action}`;
};
